var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"id":"backgroundVideo","autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.background,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }